import CommunityErrorFallback from './CommunityErrorFallback'

export default CommunityErrorFallback
